import React, { Component, Fragment } from 'react';
import Navbar from "../layout/Navbar";
import Footer from '../layout/Footer';
import AuthService from '../auth/services/authService';
import SearchService from './services/SearchService';
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBInput,
    MDBDataTable,
    MDBIcon,
    MDBAlert,
    MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink
  } from "mdbreact";

class Search2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            sResults: [],
            loading: true,
            items: {
                default: "1",
            }
        }
    }
    togglePills = (type, tab) => e => {
        e.preventDefault();
        if (this.state.items[type] !== tab) {
          let items = { ...this.state.items };
          items[type] = tab;
          this.setState({
            items
          });
        }
      };

    handleChange = (e) => {
        this.setState({
            [e.target.id] : e.target.value
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const s = {
            id: this.state.search
        }
        AuthService.apiAuth().then((res) => {
            const token = res.data;
            const authToken = token.TOKEN;
            SearchService.searchResults(authToken, {jsStruct: JSON.stringify(s)}).then(res => {
                const sResults = res.data.rows;
                this.setState({ sResults, loading: false});
                console.log(sResults);
            });
        })
    }


    render() {
        const sResults = this.state.sResults;
        const {loading} = this.state;
        const data = {

            columns: [
              {
                label: "Course Name",
                field: "Sinclair_Course_Nm",
                width: 150,
              },
              {
                label: "Transfer Course Name",
                field: "Transfer_Course_Title_Nm",
                width: 150,
              }
            ],
            rows : sResults.map(s => {
                return {
                    Sinclair_Course_Nm: s.Sinclair_Course_Nm,
                    Transfer_Course_Title_Nm: s.Transfer_Course_Title_Nm
                }
            })
          }


        return (
        <Fragment>
            <Navbar />
            <MDBContainer>
                <MDBRow>
                    <MDBCol md="8" className="offset-md-2 mt-5">
                        <MDBNav pills color="red darken-2" className="text-center mt-5">
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "1"}
                                onClick={this.togglePills("default", "1")}
                                >
                                Search by institution
                                </MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "2"}
                                onClick={this.togglePills("default", "2")}
                                >
                                Search by Transfer Course Name
                                </MDBNavLink>
                            </MDBNavItem>
                            <MDBNavItem>
                                <MDBNavLink
                                link
                                to="#"
                                active={this.state.items["default"] === "3"}
                                onClick={this.togglePills("default", "3")}
                                >
                                Search by Sinclair Course
                                </MDBNavLink>
                            </MDBNavItem>
                        </MDBNav>
       <MDBTabContent activeItem={this.state.items["default"]}>
          <MDBTabPane tabId="1">
            <form>
                <div className="grey-text">
                    <MDBInput
                        label="Type your search"
                        icon="search"
                        id="search"
                        group
                        value={this.state.search}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="text-center mt-4">
                <MDBBtn color="red" className="mb-3" type="submit" onClick={this.handleSubmit}>
                    Submit Search
                </MDBBtn>
                </div>
            </form>
          </MDBTabPane>
          <MDBTabPane tabId="2">
            <form>
                <div className="grey-text">
                    <MDBInput
                        label="Type your search"
                        icon="search"
                        id="search"
                        group
                        value={this.state.search}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="text-center mt-4">
                <MDBBtn color="red" className="mb-3" type="submit" onClick={this.handleSubmit}>
                    Submit Search
                </MDBBtn>
                </div>
            </form>
          </MDBTabPane>
          <MDBTabPane tabId="3">
            <form>
                <div className="grey-text">
                    <MDBInput
                        label="Type your search"
                        icon="search"
                        id="search"
                        group
                        value={this.state.search}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="text-center mt-4">
                <MDBBtn color="red" className="mb-3" type="submit" onClick={this.handleSubmit}>
                    Submit Search
                </MDBBtn>
                </div>
            </form>
          </MDBTabPane>
        </MDBTabContent>
        </MDBCol>
                </MDBRow>
        <MDBRow className="mt-3 mb-5">
            <MDBCol md="12">
                <MDBDataTable striped bordered small entries={50} entriesOptions={[50, 100, 150]} data={data} exportToCSV />
            </MDBCol>
        </MDBRow>
            </MDBContainer>
            <Footer />
        </Fragment> );
    }
}

export default Search2;